import ClassList from '../../slices/class/ClassList'
import ClassDetails from '../../slices/class/ClassDetails'

const classReducer = {
    classList: ClassList,
    classDetails: ClassDetails,
};

export default classReducer;
